var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckCircleFilledIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99987 12.4856C10.0295 12.4856 12.4856 10.0296 12.4856 6.99987C12.4856 3.9702 10.0295 1.51416 6.99987 1.51416C3.9702 1.51416 1.51416 3.9702 1.51416 6.99987C1.51416 10.0296 3.9702 12.4856 6.99987 12.4856ZM9.54189 6.11332C9.80968 5.84553 9.80968 5.41136 9.54189 5.14357C9.2741 4.87578 8.83993 4.87578 8.57214 5.14357L6.31416 7.40156L5.4276 6.515C5.15982 6.24721 4.72565 6.24721 4.45786 6.515C4.19007 6.78279 4.19007 7.21696 4.45786 7.48475L5.82929 8.85618C6.09707 9.12396 6.53124 9.12396 6.79903 8.85618L9.54189 6.11332Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleFilledIcon);
export default __webpack_public_path__ + "static/media/check-circle-filled-icon.312c4980b18fbc793d6e760857424838.svg";
export { ForwardRef as ReactComponent };